import AxiosManager from "@/util/axiosLib/axiosManager";
import apiManager from "./apiManager";

var apiUrl=process.env.VUE_APP_apiUrl +"/";
// var apiUrl="http://127.0.0.1:8000/";
// var apiUrl= "https://kianseng.org/"
// var apiPathBase="api/test/";
var apiPathBase="api/admin/";





export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },

    // api_Test ( data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    // },
    // api_Upload (file, data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_UpdateFile("upload",file,data)
    // },

    //---------------------------------------
    api_admWebContent_SaveContent (queryType,data01)
    {
        let data={
            queryType:queryType,
            data01:JSON.stringify(data01),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_SaveContent",data)
    },
    api_admWebContent_SaveContent_byUserId (relUserId, queryType,data01)
    {
        let data={
            relUserId:relUserId,
            queryType:queryType,
            data01:JSON.stringify(data01),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_SaveContent_byUserId",data)
    },
    api_admWebContent_SaveContent_byId01 (relId01, queryType,data01)
    {
        let data={
            relId01:relId01,
            queryType:queryType,
            data01:JSON.stringify(data01),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_SaveContent_byId01",data)
    },
    api_admWebContent_QueryContent (queryType)
    {
        let data={
            queryType:queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_QueryContent",data)
    },
    api_admWebContent_QueryContent_byUserId (queryType,relUserId)
    {
        let data={
            queryType:queryType,
            relUserId:relUserId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_QueryContent_byUserId",data)
    },
    api_admWebContent_QueryContent_byId01 (queryType,relId01)
    {
        let data={
            queryType:queryType,
            relId01:relId01,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_QueryContent_byId01",data)
    },
    api_admWebContent_QueryContent_Multi (queryType)
    {
        let data={
            queryType:queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_QueryContent_Multi",data)
    },
    api_admWebContent_Delete_Multi (idTokenStr)
    {
        let data={
            idTokenStr:idTokenStr,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_Delete_Multi",data)
    },
    api_admWebContent_Delete (id)
    {
        let data={
            id:id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admWebContent_Delete",data)
    },
    api_admSetting_Save (key,value)
    {
        let data={
            key:key,
            value:value,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admSetting_Save",data)
    },
    api_admSetting_GetValueOrDefault (key)
    {
        let data={
            key:key,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("admSetting_GetValueOrDefault",data)
    },

    //---------------
    api_upload (file, data)
    {
        return this.getApiManager().api_UpdateFile("upload",file,data)
    },
    api_uploadProductImage (file, data)
    {
        return this.getApiManager().api_UpdateFile("uploadProductImage",file,data)
    },
    api_uploadFileRemove (fileNamePathRelUpload)
    {
        let data={
            fileNamePathRelUpload:fileNamePathRelUpload,
        }
        return this.getApiManager().api_CallMethod_ByParamObj("uploadFileRemove",data)
    },
    api_uploadWaitProcess (file)
    {
        return this.getApiManager().api_UpdateFile("uploadWaitProcess",file,{})
    },

    init($jsonStr){
        if ($jsonStr===""){
            return [];
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnString($jsonStr){
        if ($jsonStr===""){
            return "";
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnObject($jsonStr){
        if ($jsonStr===""){
            return {};
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnObjectWithTemplate($jsonStr,template){
        if ($jsonStr===""){
            return {...template};
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnArray(arrWork){

        return arrWork;
        // var arrResult = arrWork.map(function(item, index, array){
        //     return JSON.parse(item);
        // });

        // return arrResult;
    },

    api_Admin_Question_Query ()
    {
        let data={
            "a":"xx"
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getQuestion",data)
    },

    api_getContent2 ( $queryType)
    {
        let data={
            queryType:$queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getContent2",data)
    },
}
